import { styled, Box, IconButton, alpha } from '@mui/material';

export const BoxUserStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(4),
}));

export const BoxQualificationsStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
}));
interface FilterIconBoxProps {
  attrs: { active: boolean };
}
export const FilterIconBox = styled(IconButton)<FilterIconBoxProps>(
  ({ theme, attrs: { active } }) => ({
    background: theme.palette.white.main,
    borderRadius: theme.spacing(1),
    width: '45.13px',
    height: '45.13px',
    position: 'relative',
    border: '1px solid',
    borderColor: active
      ? theme.palette.primary.main
      : alpha(theme.palette.dark.dark_4, 0.24),
  }),
);
export const FilterCounterStyled = styled('div')(({ theme }) => ({
  position: 'absolute',
  background: theme.palette.error.main,
  height: '24px',
  color: theme.palette.white.main,
  width: '21px',
  top: -10,
  right: -8,
  borderRadius: '10px 0px 0px 10px',
  fontSize: '12px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRight: '1px solid',
  borderColor: alpha(theme.palette.error.main, 0.2),
}));
export const FilterResetStyled = styled('div')(({ theme }) => ({
  position: 'absolute',
  background: theme.palette.error.main,
  height: '24px',
  color: theme.palette.white.main,
  width: '21px',
  top: -10,
  right: -29,
  borderRadius: '0px 10px 10px 0px',
  fontSize: '12px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderLeft: '1px solid',
  borderColor: alpha(theme.palette.error.main, 0.2),
  cursor: 'pointer',
}));
export const FilterButtonContainerStyled = styled('div')(({ theme }) => ({
  position: 'relative',
}));
